// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1EtV_","file":"styles_file__3_4Hi"};